import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import SpeedTestWeb from "./pages/SpeedTestWeb";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <div style={{ height: "0.9375rem" }} />
      <Router>
        <Routes>
          <Route path="/" element={<SpeedTestWeb />} />
        </Routes>
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
